import React, { useState, useEffect } from 'react';
import './Navbar.css';
import LogoShield from './LogoShield';

// Cache-busting version for logo (update this when logo changes)
const LOGO_VERSION = '2.0';

const Navbar = ({ onSectionChange }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleSectionClick = (sectionId) => {
    if (onSectionChange) {
      onSectionChange(sectionId);
    }
    setIsMenuOpen(false);
    // Scroll to top when changing sections
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogoClick = () => {
    if (onSectionChange) {
      onSectionChange('home');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <LogoShield onClick={handleLogoClick} />
          <div className="logo-text">
            <span className="logo-name">Rivontrix</span>
            <span className="logo-tagline">Your Technology Partner</span>
          </div>
        </div>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li><a href="#industries" onClick={(e) => { e.preventDefault(); handleSectionClick('industries'); }}>Industries</a></li>
          <li><a href="#insights" onClick={(e) => { e.preventDefault(); handleSectionClick('insights'); }}>Insights</a></li>
          <li><a href="#services" onClick={(e) => { e.preventDefault(); handleSectionClick('services'); }}>Services</a></li>
          <li><a href="#divisions" onClick={(e) => { e.preventDefault(); handleSectionClick('divisions'); }}>Divisions</a></li>
          {/* <li><a href="#partnership" onClick={(e) => { e.preventDefault(); handleSectionClick('partnership'); }}>Partner & Invest</a></li> */}
          <li><a href="#careers" onClick={(e) => { e.preventDefault(); handleSectionClick('careers'); }}>Careers</a></li>
          <li><a href="#about" onClick={(e) => { e.preventDefault(); handleSectionClick('about'); }}>About Us</a></li>
          <li><a href="#contact" onClick={(e) => { e.preventDefault(); handleSectionClick('contact'); }}>Contact Us</a></li>
        </ul>
        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

